import { createApp } from 'vue';
import App from './AiChat.vue';
import '@/assets/styles.scss';
import '@/assets/aiChat.scss';

// WordPress 模板中的 Vue 挂载节点。
const mountElement = document.querySelector<HTMLElement>('#ai-app');

if (!mountElement) {
  console.error('[AI Page] 未找到 #ai-app，Vue 应用无法挂载。');
} else {
  createApp(App).mount(mountElement);
}
